import React, { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLoader } from '../../_helper/LoaderContext';
import { usePharmacy } from '../../_helper/PharmacyProvider';
import { addNewItem, addSaltNameApi } from '../PharmacyMedicineAdd/PharmacyMedicineService';
import { toast } from 'react-toastify';
import { Breadcrumbs, ToolTip } from '../../AbstractElements';
import { Button, Card, CardBody, CardHeader, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { ArrowLeft, PlusCircle } from 'react-feather';
import { useDisableScrollOnFocus } from '../../Hooks/useDisableScrollOnFocus';
import AsyncSelect from "react-select/async";
import { productForms } from '../PharmacyMedicineAdd/UpdateMedicine';

// import { packageTypes, productForms } from '../PharmacyMedicineAdd/UpdateMedicine';

// OTC product forms (sorted alphabetically)
export const otcProductForms = [
	{ id: 1, name: "Balm / Stick", value: "balm" },
	{ id: 2, name: "Biscuits / Snacks", value: "snack" },
	{ id: 3, name: "Capsule", value: "capsule" },
	{ id: 4, name: "Chewable Tablet", value: "chewable_tablet" },
	{ id: 5, name: "Cream", value: "cream" },
	{ id: 6, name: "Drops", value: "drops" },
	{ id: 7, name: "Drinks / Beverages", value: "drink" },
	{ id: 8, name: "Effervescent Tablet", value: "effervescent_tablet" },
	{ id: 9, name: "Film / Oral Film", value: "oral_film" },
	{ id: 10, name: "Gel", value: "gel" },
	{ id: 11, name: "Gummy / Chewable Bar", value: "gummy" },
	{ id: 12, name: "Lotion", value: "lotion" },
	{ id: 13, name: "Lozenge / Troche", value: "lozenge" },
	{ id: 14, name: "Medicated Soap / Bar", value: "medicated_soap" },
	{ id: 15, name: "Nebulizer Solution", value: "nebulizer_solution" },
	{ id: 16, name: "Patch", value: "patch" },
	{ id: 17, name: "Powder", value: "powder" },
	{ id: 18, name: "Powder for Infusion / Injection (reconstitution)", value: "powder_for_infusion" },
	{ id: 19, name: "Powder for Suspension", value: "powder_for_suspension" },
	{ id: 20, name: "Syrup / Oral Solution", value: "syrup" },
	{ id: 21, name: "Soft Gelatin Capsule", value: "soft_gelatin_capsule" },
	{ id: 22, name: "Spray / Inhaler", value: "spray" },
	{ id: 23, name: "Suppository", value: "suppository" },
	{ id: 24, name: "Tablet", value: "tablet" },
	{ id: 25, name: "Other", value: "other" }
]

// OTC package types (sorted alphabetically)
export const otcPackageTypes = [
	{ id: 1, name: "Ampoule / Vial", value: "ampoule" },
	{ id: 2, name: "Blister Pack", value: "blister_pack" },
	{ id: 3, name: "Bottle", value: "bottle" },
	{ id: 4, name: "Box / Carton", value: "box" },
	{ id: 5, name: "Dropper + Bottle Combo", value: "dropper_combo" },
	{ id: 6, name: "Dropper Bottle", value: "dropper_bottle" },
	{ id: 7, name: "Foil Pack / Foil Sachet", value: "foil_pack" },
	{ id: 8, name: "Jar", value: "jar" },
	{ id: 9, name: "Jar with Screw Cap", value: "jar_screw_cap" },
	{ id: 10, name: "Pump Bottle", value: "pump_bottle" },
	{ id: 11, name: "Package", value: "package" },
	{ id: 12, name: "Roll-on / Pen Dispenser", value: "roll_on" },
	{ id: 13, name: "Sachet / Pouch", value: "sachet" },
	{ id: 14, name: "Spray Bottle / Aerosol", value: "spray_bottle" },
	{ id: 15, name: "Stick Pack / Stick Tube", value: "stick_pack" },
	{ id: 16, name: "Tube", value: "tube" },
	{ id: 17, name: "Tube with Nozzle", value: "tube_nozzle" },
	{ id: 18, name: "Other", value: "other" }
]

const AddOTC = () => {
	const { t } = useTranslation();
	const history = useNavigate();
	const { setLoading } = useLoader();
	const { pharmacyPOS } = usePharmacy();

	const [formData, setFormData] = useState({
		brandName: "",
		// saltName: "",
		manufacturer: "",
		package: "",
		productForm: "",
		quantity: "",
		regularPrice: "",
		sellingPrice: "",
		note: "",
		minAlertQuantity: "",
		currency: "INR"
	});

	const [errors, setErrors] = useState({});
	const [searchQuery, setSearchQuery] = useState("");
	const disableScrollProps = useDisableScrollOnFocus();

	const [filterTooltipOpen, setFilterTooltipOpen] = useState(false);
	const toggleFilterTooltip = () => setFilterTooltipOpen(!filterTooltipOpen);
	// ✅ Load medicines on search
	const loadMedicines = async (inputValue) => {
		// if (!inputValue) return [];
		if (!inputValue || inputValue.length < 3) {
			return [];
		}

		const body = {
			search: inputValue,
			// clinicId: pharmacyPOS?.hospital_id,
		};

		// try {
		// 	setLoading(true);
		// 	const response = await getSaltOnSearch(body);
		// 	const medicines = response.data.data.medication || [];

		// 	return medicines.map((m) => ({
		// 		value: m.medication_id,
		// 		// label: `${m.salt_composition}`,
		// 		label: `${m.medication_name}`,
		// 		raw: m
		// 	}));
		// } catch (error) {
		// 	console.error("Error fetching medicines:", error);
		// 	return [];
		// } finally {
		// 	setLoading(false);
		// }
	};

	const handleMedicineSearchChange = (newValue) => {
		setSearchQuery(newValue);
	};

	// ✅ When a medicine is selected
	const handleSelectMedicine = (selectedOption) => {
		if (!selectedOption) {
			setFormData((prev) => ({ ...prev, saltName: "" }));
			return;
		}
		const medicine = selectedOption.raw;
		setFormData((prev) => ({
			...prev,
			// saltName: medicine.salt_composition || "",
			saltName: medicine.medication_name || "",
			// brandName: medicine.product_name || prev.brandName,
			// manufacturer: medicine.manufacturer_name || prev.manufacturer,
		}));
	};

	// ✅ Handle input change
	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	// ✅ Validation
	const validate = () => {
		let newErrors = {};
		if (!formData.brandName) newErrors.brandName = "Products name is required";
		// if (!formData.saltName) newErrors.saltName = "Salt name is required";
		if (!formData.manufacturer) newErrors.manufacturer = "Manufacturer is required";
		if (!formData.package) newErrors.package = "Package is required";
		if (!formData.productForm) newErrors.productForm = "Product form is required";
		if (!formData.quantity || formData.quantity <= 0) newErrors.quantity = "Quantity must be greater than 0";
		if (!formData.regularPrice || formData.regularPrice <= 0) newErrors.regularPrice = "Price must be greater than 0";
		if (!formData.minAlertQuantity) newErrors.minAlertQuantity = "Minimum Alert quantity is required";
		if (!formData.currency) newErrors.currency = "Currency is required";
		return newErrors;
	};

	// ✅ Submit add
	const handleSubmit = async (e) => {
		e.preventDefault();
		const validationErrors = validate();
		if (Object.keys(validationErrors).length > 0) {
			setErrors(validationErrors);
			return;
		}
		try {
			setLoading(true);

			const body = {
				clinicId: pharmacyPOS?.hospital_id,
				brandName: formData.brandName,
				// saltName: formData.saltName,
				manufacturer: formData.manufacturer,
				package: formData.package,
				productForm: formData.productForm,
				packageQuantity: formData.quantity,
				regularPrice: formData.regularPrice,
				note: formData.note,
				minQuantityAlert: formData.minAlertQuantity,
				currency: formData.currency,
				isOTC: true
			}

			const response = await addNewItem(body);
			toast.success(response.data.message);
			gotoList();
		} catch (error) {
			console.error("Error adding item:", error);
		} finally {
			setLoading(false);
		}
	};

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/items`);
	};

	const [saltRows, setSaltRows] = useState([{ saltName: "", dosage: "" }]);
	const [productForm, setProductForm] = useState("");
	const [isSaltModalOpen, setSaltModalOpen] = useState(false);
	// const [newSaltName, setNewSaltName] = useState("");
	const [saltModalError, setSaltModalError] = useState("");
	const [isSaltSubmitting, setSaltSubmitting] = useState(false);

	// Add new row
	const addRow = () => {
		setSaltRows([...saltRows, { saltName: "", dosage: "" }]);
	};

	// Remove row
	const removeRow = (index) => {
		const updated = saltRows.filter((_, i) => i !== index);
		setSaltRows(updated.length ? updated : [{ saltName: "", dosage: "" }]); // keep at least one
	};

	// Handle input change
	const handleRowChange = (index, field, value) => {
		const updated = [...saltRows];
		updated[index][field] = value;
		setSaltRows(updated);
	};

	// Open/close modal
	const toggleSaltModal = () => {
		setSaltModalOpen(!isSaltModalOpen);
		setSaltModalError("");
		setSaltRows([{ saltName: "", dosage: "" }]);
		setProductForm("");
	};

	const handleSaltModalSubmit = async (e) => {
		e.preventDefault();

		// ✅ Validation
		for (let i = 0; i < saltRows.length; i++) {
			if (!saltRows[i].saltName.trim()) {
				setSaltModalError(`Salt name is required in row ${i + 1}`);
				return;
			}
			if (!saltRows[i].dosage.trim()) {
				setSaltModalError(`Dosage is required in row ${i + 1}`);
				return;
			}
		}
		if (!productForm) {
			setSaltModalError("Product form is required");
			return;
		}

		// ✅ Build API body
		const saltname_with_dosage = saltRows
			.map((row) => `${row.saltName} (${row.dosage})`)
			.join(" + ");
		const saltname_without_dosage = saltRows.map((row) => row.saltName).join(" + ");

		const body = {
			salt_composition: saltname_with_dosage,
			salt_composition_new: saltname_without_dosage,
			product_form: productForm,
		};

		console.log("submit body", body);

		try {
			setLoading(true);
			setSaltSubmitting(true);
			// Call your API here
			const response = await addSaltNameApi(body);

			if (response.data.status === "success") {
				// ✅ Set salt name & id in parent form
				// setFormData((prev) => ({
				// 	...prev,
				// 	saltName: response.data.medication_name,
				// 	saltId: response.data.medication_id,
				// }));
				toast.success(response.data.message);
				toggleSaltModal();
			}
			// else {
			// 	setSaltModalError(response.data.message);
			// }
		} catch (error) {
			// setSaltModalError(error.message);
		} finally {
			setLoading(false);
			setSaltSubmitting(false);
		}
	};

	return (
		<Fragment>
			<Breadcrumbs mainTitle={t("Add OTC Item")} parent={t("Dashboard")} title={t("Add OTC Item")} />
			<Row className="mt-3">
				<Col sm={12}>
					<Card>
						<CardHeader className="d-flex justify-content-end align-items-center">
							<button
								className="btn btn-primary d-flex align-items-center"
								style={{ color: "white", height: "40px" }}
								onClick={gotoList}
							>
								<ArrowLeft className="me-2" /> {t("Back")}
							</button>
						</CardHeader>
						<CardBody>
							<form onSubmit={handleSubmit} className="row g-3">

								{/* Product Name */}
								<div className="col-md-4">
									<label className="form-label">{t("Product Name")}</label>
									<input
										type="text"
										name="brandName"
										value={formData.brandName}
										onChange={handleChange}
										className="form-control"
									/>
									{errors.brandName && <div className="text-danger">{errors.brandName}</div>}
								</div>
								{/* <div className="col-md-4">
									<label className="form-label">{t("Product Name")}</label>
									<div className="input-group">
										<AsyncSelect
											className="flex-grow-1"
											cacheOptions
											loadOptions={loadMedicines}
											defaultOptions={[]}
											onChange={handleSelectMedicine}
											placeholder={t("Search & select an item")}
											onInputChange={handleMedicineSearchChange}
											noOptionsMessage={() =>
												searchQuery.length >= 3
													? t("No medications found. Try another name.")
													: t("Type at least 3 characters to search...")
											}
											isClearable={true}
											styles={{
												container: (base) => ({
													...base,
													flex: 1,
												}),
											}}
										/>
										<div className="input-group-append" style={{ cursor: "pointer" }}>
											<span
												className="input-group-text cursor-pointer"
												id="FilterToolTip"
												onClick={toggleSaltModal}
											>
												<PlusCircle />
											</span>
											<ToolTip
												attrToolTip={{
													placement: 'top',
													isOpen: filterTooltipOpen,
													target: 'FilterToolTip',
													toggle: toggleFilterTooltip,
												}}
											>
												<strong>{t("Add New Product Name")}</strong>
											</ToolTip>
										</div>
									</div>

									{errors.saltName && <div className="text-danger">{errors.saltName}</div>}
								</div> */}
								{/* Manufacturer */}
								<div className="col-md-4">
									<label className="form-label">{t("Manufacturer")}</label>
									<input
										type="text"
										name="manufacturer"
										value={formData.manufacturer}
										onChange={handleChange}
										className="form-control"
									/>
									{errors.manufacturer && <div className="text-danger">{errors.manufacturer}</div>}
								</div>

								{/* Package */}
								<div className="col-md-4">
									<label className="form-label">Package</label>
									<select
										name="package"
										value={formData.package}
										onChange={handleChange}
										className="form-select"
									>
										<option value="">Select Package</option>
										{otcPackageTypes.map((pkg) => (
											<option key={pkg.id} value={pkg.name}>
												{pkg.name}
											</option>
										))}
									</select>
									{errors.package && <div className="text-danger">{errors.package}</div>}
								</div>

								{/* Product Form */}
								<div className="col-md-4">
									<label className="form-label">Product Form</label>
									<select
										name="productForm"
										value={formData.productForm}
										onChange={handleChange}
										className="form-select"
									>
										<option value="">Select Product Form</option>
										{otcProductForms.map((form) => (
											<option key={form.id} value={form.name}>
												{form.name}
											</option>
										))}
									</select>
									{errors.productForm && <div className="text-danger">{errors.productForm}</div>}
								</div>

								{/* Quantity */}
								<div className="col-md-4">
									<label className="form-label">Quantity</label>
									<input
										type="number"
										name="quantity"
										min={1}
										value={formData.quantity}
										onChange={handleChange}
										className="form-control"
										{...disableScrollProps}
									/>
									{errors.quantity && <div className="text-danger">{errors.quantity}</div>}
								</div>

								{/* MRP */}
								<div className="col-md-4">
									<label className="form-label">MRP</label>
									<input
										type="number"
										name="regularPrice"
										value={formData.regularPrice}
										onChange={handleChange}
										className="form-control"
										{...disableScrollProps}
									/>
									{errors.regularPrice && <div className="text-danger">{errors.regularPrice}</div>}
								</div>

								{/* Currency */}
								<div className="col-md-4">
									<label className="form-label">Currency</label>
									<select
										name="currency"
										value={formData.currency}
										onChange={handleChange}
										className="form-select"
										disabled
									>
										<option value="INR">INR</option>
									</select>
									{errors.currency && <div className="text-danger">{errors.currency}</div>}
								</div>

								{/* Alert Quantity */}
								<div className="col-md-4">
									<label className="form-label">Minimum Alert Quantity</label>
									<input
										type="number"
										name="minAlertQuantity"
										min={0}
										value={formData.minAlertQuantity}
										onChange={handleChange}
										className="form-control"
										{...disableScrollProps}
									/>
									{errors.minAlertQuantity && <div className="text-danger">{errors.minAlertQuantity}</div>}
								</div>

								{/* Note */}
								<div className="col-md-12">
									<label className="form-label">Note</label>
									<textarea
										name="note"
										value={formData.note}
										onChange={handleChange}
										className="form-control"
									/>
								</div>

								{/* Buttons */}
								<div className="d-flex justify-content-end gap-2">
									<button className="btn btn-primary" type="submit">
										{t("Add Item")}
									</button>
									<Button color="secondary" onClick={gotoList}>
										{t("Cancel")}
									</Button>
								</div>
							</form>
						</CardBody>
					</Card>
				</Col>
			</Row>
			{/* Product Name Modal */}
			<Modal isOpen={isSaltModalOpen} toggle={toggleSaltModal} size="lg">
				<ModalHeader toggle={toggleSaltModal}>{t("Add New Product Name")}</ModalHeader>
				<form onSubmit={handleSaltModalSubmit}>
					<ModalBody>
						{saltRows.map((row, index) => (
							<div className="row mb-3 align-items-end" key={index}>
								<div className="col-md-6">
									<label className="form-label">{t("Product Name")}</label>
									<input
										type="text"
										className="form-control"
										value={row.saltName}
										onChange={(e) => handleRowChange(index, "saltName", e.target.value)}
										disabled={isSaltSubmitting}
									/>
								</div>
								<div className="col-md-3">
									<label className="form-label">{t("Dosage")}</label>
									<input
										type="text"
										className="form-control"
										value={row.dosage}
										onChange={(e) => handleRowChange(index, "dosage", e.target.value)}
										disabled={isSaltSubmitting}
									/>
								</div>
								<div className="col-md-3 d-flex gap-2">
									<Button
										color="success"
										type="button"
										onClick={addRow}
										disabled={isSaltSubmitting}
									>
										+
									</Button>
									{saltRows.length > 1 && (
										<Button
											color="danger"
											type="button"
											onClick={() => removeRow(index)}
											disabled={isSaltSubmitting}
										>
											–
										</Button>
									)}
								</div>
							</div>
						))}

						{/* Product Form */}
						<div className="mb-3">
							<label className="form-label">{t("Product Form")}</label>
							<select
								className="form-select"
								value={productForm}
								onChange={(e) => setProductForm(e.target.value)}
								disabled={isSaltSubmitting}
							>
								<option value="">{t("Select Product Form")}</option>
								{productForms.map((form) => (
									<option key={form.id} value={form.name}>
										{form.name}
									</option>
								))}
							</select>
						</div>

						{saltModalError && <div className="alert alert-danger dark fade show mt-2">{saltModalError}</div>}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" type="submit" disabled={isSaltSubmitting}>
							{isSaltSubmitting ? t("Adding...") : t("Add")}
						</Button>
						<Button color="secondary" type="button" onClick={toggleSaltModal} disabled={isSaltSubmitting}>
							{t("Cancel")}
						</Button>
					</ModalFooter>
				</form>
			</Modal>
		</Fragment>
	);
}

export default AddOTC